module.exports = __webpack_public_path__ + "img/studywayIcon4.bb887237.png";